/**
 * Módulo: Accordion
 * Toggle de itens colapsáveis com animação de altura.
 */

export function initAccordion() {
  const containers = document.querySelectorAll('[data-accordion]:not([data-accordion-initialized])');

  if (!containers.length) return;

  containers.forEach(container => {
    container.setAttribute('data-accordion-initialized', 'true');
    const items = container.querySelectorAll('[data-accordion-item]');

    items.forEach(item => {
      const toggle = item.querySelector('[data-accordion-toggle]');
      const body = item.querySelector('[data-accordion-body]');

      if (!toggle || !body) return;

      toggle.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          // Fechar
          body.style.maxHeight = '0';
          item.classList.remove('is-open');
        } else {
          // Abrir
          body.style.maxHeight = body.scrollHeight + 'px';
          item.classList.add('is-open');
        }
      });
    });
  });
}
